import React from "react";
import { Card, Modal, Message, Divider } from "semantic-ui-react";
import Reader from "./Reader";

class ScrapeBookDetails extends React.Component {
  render() {
    const { overview, details } = this.props;
    return (
      <Card>
        <Card.Content>
          <Card.Header>
            {overview.title}
            <br />
            <small>By: {overview.author}</small>
          </Card.Header>
          <Card.Description>
            <Message>
              <Message.Content>
                {overview.excerpt}
                <Divider />
                <Modal trigger={<a>Read more +</a>} basic>
                  <Modal.Header>
                    {overview.title}
                    <br />
                    <small>By: {overview.author}</small>
                    <br />
                    <a href={overview.url} target="_blank">
                      <small>
                        Open link{" "}
                        <span role="img" aria-label="arrow icon">
                          ↗️
                        </span>
                      </small>
                    </a>
                  </Modal.Header>
                  <Modal.Content>
                    <Reader content={details.content} />

                    <Divider />
                  </Modal.Content>
                </Modal>
              </Message.Content>
            </Message>
          </Card.Description>
        </Card.Content>
      </Card>
    );
  }
}

export default ScrapeBookDetails;



// WEBPACK FOOTER //
// ./src/components/ScrapBookDetails.js